import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {DatePipe} from '@angular/common';
import {
  ChartEntry,
  ChartFormatOptions,
  DataService,
  GetOrderChartDataDocument,
  MetricType,
} from '@vendure/admin-ui/core';
import {BehaviorSubject, combineLatest, Observable, Subject, switchMap} from 'rxjs';
import {distinctUntilChanged, map, startWith} from 'rxjs/operators';
// import {GET_ORDER_CHART_DATA} from '@vendure/admin-ui/dashboard';
import {LineChartOptions} from 'chartist';
import {tooltipPlugin} from '../../chart/tooltip-plugin';

@Component({
  selector: 'app-order-chart-widget',
  templateUrl: './order-chart-widget.component.html',
  styleUrls: ['./order-chart-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderChartWidgetComponent implements OnInit {
  constructor(private dataService: DataService) {}
  metrics$: Observable<Array<ChartEntry>[]>;
  refresh$ = new Subject<boolean>();
  metricType$ = new BehaviorSubject(MetricType.OrderTotal);
  MetricType = MetricType;

  chartOptions: LineChartOptions;

  ngOnInit() {
    const currencyCode$ = this.dataService.settings
      .getActiveChannel()
      .refetchOnChannelChange()
      .mapStream(data => data.activeChannel.defaultCurrencyCode || undefined);
    const uiState$ = this.dataService.client.uiState().mapStream(data => data.uiState);
    const metricType$ = this.metricType$.pipe(distinctUntilChanged());
    this.metrics$ = combineLatest(metricType$, currencyCode$, uiState$).pipe(
      switchMap(([metricType, currencyCode, uiState]) =>
        this.refresh$.pipe(
          startWith(false),
          switchMap(refresh =>
            this.dataService
              .query(GetOrderChartDataDocument, {
                types: [metricType],
                refresh,
              })
              .mapSingle(data => data.metricSummary)
              .pipe(
                map(metrics => {
                  const formatValueAs: 'currency' | 'number' =
                    metricType === MetricType.OrderCount ? 'number' : 'currency';
                  const locale = `${uiState.language}-${uiState.locale}`;

                  const formatOptions: ChartFormatOptions = {
                    formatValueAs,
                    currencyCode,
                    locale,
                  };
                  return [
                    metrics.find(m => m.type === metricType)?.entries.map(entry => ({...entry, formatOptions})) ?? [],
                  ];
                }),
              ),
          ),
        ),
      ),
    );

    this.chartOptions = this.handleChartOptions(true);
  }

  handleChangeMetricType(type: MetricType) {
    if (type === MetricType.OrderCount) {
      this.chartOptions = this.handleChartOptions(false);
    } else {
      this.chartOptions = this.handleChartOptions(true);
    }
    this.metricType$.next(type);
  }

  //  判断是否是货币相关的图
  handleChartOptions(isCurrency: boolean) {
    return {
      low: 0,
      showArea: true,
      showLine: true,
      showPoint: true,
      fullWidth: true,
      axisX: {
        showLabel: true,
        showGrid: false,
        offset: 60,
        labelInterpolationFnc: function (value: Date) {
          return new DatePipe('en-US').transform(value, 'MM.dd');
        },
      },
      axisY: {
        showLabel: true,
        offset: 60,
        labelInterpolationFnc: function (value: number | string) {
          return isCurrency ? `¥${(Number(value ?? 0) / 100).toFixed(0)}` : value;
        },
      },
      plugins: [tooltipPlugin()],
    };
  }

  refresh() {
    this.refresh$.next(true);
  }
}
